<template>
    <div id="video_container" v-show="showVideo">
        <video playsinline ref="videoPlayer" id='video' class="video-js vjs-default-skin vjs-big-play-centered"
               controls
               :height='height'
        ></video>
        <button id="closeVideo" v-on:click="destroy">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                             id="Capa_1" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;"
                             xml:space="preserve" width="30px" height="30px" class=""><g>
                <circle cx="25" cy="25" r="25" data-original="#D75A4A" class="active-path" data-old_color="#353232" fill="#363333"/>
                <polyline style="stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;" points="16,34 25,25 34,16   " stroke="#ffffff" fill="#ffffff"/>
                <polyline style="stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;" points="16,16 25,25 34,34   " stroke="#ffffff" fill="#ffffff"/></g>
            </svg>
        </button>
    </div>
</template>

<script>
    import videojs from 'video.js';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';

    export default {
        name: "VideoPlayer",
        mixins:[common,storeMapper],
        methods: {
            setOptions(options, url)
            {
                this.options = options;
                if (this.player) {
                    this.player.reset();
                    this.player.currentTime(0);
                    this.player.src({type: 'video/mp4', src: url});
                    this.player.load();
                    if (!this.checkIsMobile()) {
                        this.player.play();
                        this.player.requestFullscreen();
                    }

                }

                document.getElementById('video').style.top = this.top+"px";
                document.getElementById('video').style.height = this.height+"px";

                if (!this.checkIsMobile()) {
                    document.getElementById('video').style.width = this.width+"px";

                }
                this.showVideo = true;

            },
            destroy() {

                if (this.player) {
                    this.player.reset();
                    this.player.currentTime(0);
                    if (this.player.isFullscreen()) {
                        this.player.exitFullscreen();
                    }

                }

                this.showVideo = false;

            }
        },
        data() {
            return {
                player: null,
                options: {},
                showVideo: false
            }
        },
        computed: {
            height() {
                return window.innerHeight / 1.5;
            },
            top() {
                return (window.innerHeight - 300) / 4;
            },
            width() {
                return window.innerWidth - 400;

            }
        },
        mounted() {
            let self = this;
            this.player = videojs(this.$refs.videoPlayer, this.options);
            var Button = videojs.getComponent('Button');
            var MyButton = videojs.extend(Button, {
                constructor: function() {
                    Button.apply(this, arguments);
                    /* initialize your button */
                    this.controlText("close");
                },
                handleClick: function() {
                    /* do something on click */
                    self.destroy();
                },
                buildCSSClass: function() {
                    return "vjs-icon-custombutton vjs-control vjs-button";
                }
            });
            videojs.registerComponent('MyButton', MyButton);
            var player = videojs('video');
            player.getChild('controlBar').addChild('myButton', {});


            window.onresize = function(e) {

                var width = window.innerWidth;
                var height = window.innerHeight;

                document.getElementById('video').style.top = ((height-300)/4)+"px";
                document.getElementById('video').style.height = (height/1.5)+"px";

                if (!self.checkIsMobile()) {
                    document.getElementById('video').style.width = width-400+"px";
                }
            };

        },
        beforeDestroy() {
            if (this.player) {
                this.player.reset()
            }
        }
    }
</script>

<style>
    #video_container {
        width: 100%;
        height: 100%;
        top:0;
        left: 0;
        position: fixed;
        z-index: 9999;
        background: rgba(0,0,0, 0.5);
    }
    .video-js {
        margin: 0 auto;
    }
    #closeVideo {
        position: absolute;
        top: 15px;
        right: 15px;
        background: unset;
        border: 0;
        cursor: pointer;
    }
    .vjs-control-bar span {
        color: #fff;
    }
    .vjs-icon-custombutton .vjs-icon-placeholder:before {
        content: "x";
        color: #fff;
        font-weight: 300;
        font-family: Arial, sans-serif;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/player/VideoPlayer.vue